// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CustomProperty } from './custom-property';
import { Lookup } from './lookup';
import { ReplaceField } from './replace-field';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CustomPropertyType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  customPropertyTypeId!: number;
  createdBy!: string;
  createdDate!: Date;
  customPropertySubType!: number;
  defaultValue?: string;
  description!: string;
  flags?: number;
  format!: number;
  locationId!: number;
  lookupId?: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  valueList?: string;
  customProperties!: CustomProperty[];
  lookup!: Lookup;
  replaceFields!: ReplaceField[];
}

